module.exports = __webpack_public_path__ + "static/img/lb2.fb13880.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb2.jpg
// module id = rZ2A
// module chunks = 0